import React, { FC } from 'react'
import {
    StyledNav,
    StyledNavList,
    StyledNavItem,
    StyledLink,
    StyledQuickLinks,
} from './QuickLinks.styled'
import { NavEventArgs } from '@news-mono/web-common'
import { usePageEvents } from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'
import { QuickLinksProps } from './QuickLinks'

export const QuickLinksWeb: FC<QuickLinksProps> = React.memo(
    ({ links, onEvent, hasBackgroundFill }) => {
        usePageEvents(() => {
            onEvent({
                type: DataLayerEventName.navAvailable,
                originator: 'QuickLinks',
                payload: {},
            })
        }, ['page-load-complete'])

        const handleClick = (args: NavEventArgs) => {
            onEvent({
                type: DataLayerEventName.navClicked,
                originator: 'QuickLinks',
                payload: {
                    navName: 'QuickLinks',
                    navLocation: 'Header',
                    navPos: args.navPos,
                    navText: args.navText,
                    navLink: args.navLink,
                },
            })
        }

        return (
            <StyledQuickLinks hasBackgroundFill={hasBackgroundFill || false}>
                <StyledNav>
                    <StyledNavList>
                        {links.map((item, index) => (
                            <StyledNavItem key={item.link}>
                                <StyledLink
                                    to={item.link}
                                    target={
                                        item.newWindow ? '_blank' : undefined
                                    }
                                    rel={
                                        item.newWindow ? 'noopener' : undefined
                                    }
                                    onClick={() => {
                                        handleClick({
                                            navPos: index,
                                            navText: item.name,
                                            navLink: item.link,
                                        })
                                    }}
                                >
                                    {item.name}
                                </StyledLink>
                            </StyledNavItem>
                        ))}
                    </StyledNavList>
                </StyledNav>
            </StyledQuickLinks>
        )
    },
)
QuickLinksWeb.displayName = 'QuickLinks'
